<template>
  <div :class="{'modal':true, 'is-active':show}">

    <div class="modal-background" @click="$emit('close-modal')"></div>
    <div class="modal-card">
        <header class="modal-card-head back-gradient-animation">
          <p class="modal-card-title has-text-centered">{{title}}</p>
          <button class="delete" aria-label="close" @click="$emit('close-modal')"></button>
        </header>
        <section class="modal-card-body">
            <h3 class="title is-3 has-text-grey-dark">Packs de Créditos</h3>
            <div class="columns is-centered">
                <div class="column is-7">

                    <div class="field has-text-left">
                        <div class="control is-size-4" v-for="(cost,key) in costCredits" :key="key">
                            <label class="radio">
                                <input type="radio" name="credits" v-model="form.amount" :value="key" @change="selection(cost,key)">
                            &nbsp; <span class="ml-2"></span> <span class="icon"><fa icon="coins" class="has-text-warning-dark" /></span> {{numberFormat(cost)}} Créditos <fa icon="angle-double-right" /> {{key}} {{form.currency}}
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <PayPal
                locale="es_MX"
                :amount="form.amount"
                :currency="form.currency"
                :client="{
                    sandbox: clientId,
                    production: clientId 
                }"
                :experience="{
                    name:'MUCRISIS',
                    input_fields: {
                        no_shipping: 1
                    }
                }"
                :button-style="{
                    label: 'checkout',
                    size:  'large',
                    shape: 'rect',
                    color: 'black'
                }"
                :items="form.myItems"
                @payment-completed="PaymentCompleted">
            </PayPal> -->
        </section>
    </div>

  </div>
</template>

<script>
// import PayPal from 'vue-paypal-checkout'
export default {
    name:'WebBankBuy',
    // components: {PayPal},
    props: {
        show: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        title: {
            type:String,
            default: ''
        },
        clientId: {
            type:String,
            default:''
        }
    },

    data:()=>({
      form: {
          amount:'5',
          currency:'USD',
            myItems: [
                {
                "name": "Paquete de 20.000 Créditos MUCRISIS",
                "description": "Compra de Paquete que contiene 20.000 Créditos para usar en MUCRISIS",
                "quantity": "1",
                "price": "5",
                "currency": "USD"
                },
            ],
        credits:20000
      },
    }),
    computed: {
      numberFormat() {
        return this.$store.getters.numberWithCommas
      },
      costCredits() {
          return this.$store.state.cost.credits
      }
    },
    methods: {
        selection(x,x2){
            this.form.myItems[0].name = `Paquete de ${this.numberFormat(x)} Créditos MUCRISIS.`
            this.form.myItems[0].description = `Compra de Paquete que contiene ${this.numberFormat(x)} Créditos para usar en MUCRISIS.`
            this.form.myItems[0].price = x2
            this.form.credits = x
        },
        PaymentCompleted(response) {
            response.credits_mount = this.form.credits
            this.$emit('form-submit',response)
        }
    }
}
</script>

<style scoped>
    .buttons {
        width: 100%;
    }
</style>